import Input from "components/Input/index";

const Azure = (
    {
        azureConnectionString,
        setAzureConnectionString,
        azureAccountKey,
        setAzureAccountKey,
        azureAccountName,
        setAzureAccountName,
        setVerified,
        setContinued
    }
) => {
    return (
        <>
            <div className="azure">
                <Input
                    label="Azure Account Name"
                    width="90%"
                    placeholder="<account-name>"
                    value={azureAccountName}
                    star="*"
                    clear={setAzureAccountName ? true : false}
                    autoFocus={setAzureAccountName? true : false}
                    handleClear={
                        () => {
                            if (setAzureAccountName) {
                                setAzureAccountName(""); 
                                setVerified(false); 
                                setContinued(false);
                            }
                        }
                    }
                    onChange={
                        (value) => { 
                            if (setAzureAccountName){
                                setAzureAccountName(value.target.value); 
                                setVerified(false); 
                                setContinued(false); }
                            }
                    }
                    disabled={setAzureAccountName ? false : true}
                />
                <Input
                    label="Account Key"
                    width="90%"
                    placeholder="<account-key>"
                    value={azureAccountKey}
                    maxLength={2000}
                    star="*"
                    clear={true}
                    autoFocus={setAzureAccountName? false : true}
                    handleClear={
                        () => { setAzureAccountKey(""); setVerified(false); setContinued(false); }
                    }
                    onChange={
                        (value) => { setAzureAccountKey(value.target.value); setVerified(false); setContinued(false); }
                    }
                />
                <Input
                    label="Connection String"
                    width="90%"
                    placeholder="DefaultEndpointsProtocol=https;AccountName=storagesample;AccountKey=<account-key>"
                    value={azureConnectionString}
                    maxLength={2000}
                    star="*"
                    clear={true}
                    handleClear={
                        () => { setAzureConnectionString(""); setVerified(false); setContinued(false); }
                    }
                    onChange={
                        (value) => { setAzureConnectionString(value.target.value); setVerified(false); setContinued(false); }
                    }
                />
                <a href="https://learn.microsoft.com/en-us/azure/storage/common/storage-account-create?tabs=azure-portal" target="_blank" rel="noopener noreferrer">
                    <p className="helpAzure">
                        For help?
                    </p>
                </a>
            </div>
        </>
    );
};

export default Azure;